<template>
  <form :onSubmit="login">
    <div class="login">
      <h2 class="login-header">Login</h2>

      <p v-if="$route.query.redirect">
        You need to login first.
      </p>

      <TextField
        v-model="email"
        placeholder="your@email.com"
        fullWidth
      >
        <template slot="label">
          Email
        </template>
      </TextField>
      <TextField
        v-model="pass"
        placeholder="• • • • • • • • •"
        type="password"
        fullWidth
      >
        <template slot="label">
          Password
        </template>
      </TextField>

      <p v-if="error" class="error">
        Bad login information
      </p>
      <Btn
        :onClick="login"
        variant="contained"
        color="primary"
        size="lg"
        class="login-button"
      >
        LOGIN
      </Btn>
      <div>
        Don't have an account?
        <router-link class="link register-link" to="/registration">
          Join now!
        </router-link>
      </div>
    </div>
  </form>
</template>

<script>
import TextField from "./TextField";
import Btn from "./Btn";
import { mapState } from "vuex";

export default {
  components: {
    TextField,
    Btn
  },
  data() {
    return {
      email: "",
      pass: "",
    };
  },
  computed: {
    ...mapState("auth", ["error", "isLoggedIn", "currency"]),
    ...mapState("app", ["isPresentation"])
  },
  watch: {
    isLoggedIn() {
      if (this.isLoggedIn) {
        this.$router.replace(this.$route.query.redirect || "/sportsbook");
      }
    }
  },
  methods: {
    login(e) {
      if (e) {
        e.preventDefault();
      }

      this.$store.dispatch("auth/login", {
        email: this.email,
        password: this.pass,
        currency: this.currency
      });
    }
  }
};
</script>

<style scoped>
.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 288px;
  margin: 0 auto;
  padding: 10% 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}
.login-header {
  color: #fff;
}
.login-button.login-button {
  margin: 24px 0 16px;
  width: calc(100% - 96px);
}
.error {
  color: red;
}
.register-link {
  margin-left: 4px;
}
</style>
